import ModalImage from "react-modal-image";
import React, { useEffect, useState } from 'react';
import ReactPaginate from "react-paginate";
import ".././styles/Gallery.css";
import pic1 from ".././assets/featuredevent1.jpg";
import MyModalImage from "../components/MyModalImage";
const items = [pic1,pic1,pic1,pic1,pic1,pic1,pic1,pic1,pic1,pic1,pic1,pic1,pic1,pic1,pic1];
function Items({ currentItems }) {
    return (
        <>
            {currentItems &&
                currentItems.map((item) => (
                    <MyModalImage item={item}/>
                ))}
        </>
    );
}

function PaginatedItems({ itemsPerPage }) {
    // Here we use item offsets; we could also use page offsets
    // following the API or data you're working with.
    const [itemOffset, setItemOffset] = useState(0);

    // Simulate fetching items from another resources.
    // (This could be items from props; or items loaded in a local state
    // from an API endpoint with useEffect and useState)
    const endOffset = itemOffset + itemsPerPage;
    console.log(`Loading items from ${itemOffset} to ${endOffset}`);
    const currentItems = items.slice(itemOffset, endOffset);
    const pageCount = Math.ceil(items.length / itemsPerPage);

    // Invoke when user click to request another page.
    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % items.length;
        console.log(
            `User requested page number ${event.selected}, which is offset ${newOffset}`
        );
        setItemOffset(newOffset);
    };
    return (
        <div className="gallery-page-section">
            <div className="test">
                <Items currentItems={currentItems} />
            </div>
            <ReactPaginate className="paginate"
                breakLabel="..."
                nextLabel=">"
                onPageChange={handlePageClick}
                pageRangeDisplayed={5}
                pageCount={pageCount}
                previousLabel="<"
                renderOnZeroPageCount={null}
            />
        </div>
    );
}

function Gallery() {
    return (
        <div className="gallery-page">
            <div className="container">
                <div className="gallery-banner-container" id="banner">
                    <div className="gallery-banner">
                        <h1>Gallery</h1>
                    </div>
                    
                </div>
            </div>
            <div className="container" id="images">
                <picflow-gallery id="gal_gJHfjXqaPTT8PuTA" tenant="tnt_wEpulx1p8RhmKZpl" 
                lightbox="#000000E6" no-padding="true" no-background="true" show-cover="true"></picflow-gallery>
            </div>
            
        </div>
    );
}

export default Gallery;